import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const FavoriteHollowIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FavoriteHollow",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.52 14.04c.51-.37.63-1.09.26-1.6-.22-.3-.57-.48-.94-.48H20.7c-.5 0-.94-.32-1.1-.79l-2.51-7.75c-.2-.6-.84-.93-1.45-.74-.35.11-.62.39-.74.74l-2.51 7.75c-.16.47-.6.79-1.1.79H3.16c-.63 0-1.15.51-1.16 1.14 0 .37.18.72.48.94l6.59 4.79c.4.29.57.81.42 1.28l-2.52 7.74c-.2.6.12 1.25.72 1.45.35.12.74.06 1.05-.16l6.59-4.78c.4-.29.95-.29 1.36 0l6.59 4.78c.51.38 1.23.27 1.61-.24.22-.3.28-.69.16-1.05l-2.51-7.74c-.15-.47.02-.99.42-1.28zm-8.26 6.48 2.09 6.43c.05.15-.03.31-.18.36-.09.03-.18.02-.26-.04l-5.47-3.97c-.86-.63-2.04-.63-2.9 0l-5.47 3.97c-.13.09-.3.06-.39-.06a.3.3 0 0 1-.04-.26l2.09-6.43c.32-1.03-.06-2.14-.94-2.76l-5.46-3.97a.295.295 0 0 1-.06-.4c.05-.07.14-.11.23-.11h6.59c1.19 0 2.24-.76 2.61-1.88l2.02-6.23c.05-.15.21-.23.36-.18q.135.045.18.18l2.03 6.23a2.73 2.73 0 0 0 2.62 1.88h6.59c.16 0 .28.13.28.28 0 .09-.04.17-.11.23l-5.47 3.97c-.88.62-1.26 1.73-.94 2.76"
    })
  }));
};